var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8969 2.6259L12.1531 1.21957C11.3871 0.603402 10.2811 0.739198 9.68777 1.52228L0.555349 13.5769L0 19.1161L5.07822 17.2199L14.209 5.16747C14.497 4.78734 14.6234 4.31376 14.5644 3.83339C14.5056 3.354 14.2693 2.92495 13.8969 2.6259ZM3.90658 15.5749L3.39829 15.7654L2.32953 14.9037L2.38492 14.3502L8.72442 5.98181L10.2462 7.20755L3.90658 15.5749ZM9.90917 4.42489L11.4309 5.65062L12.6406 4.05405L11.119 2.82928L9.90917 4.42489ZM16.1476 13.3003H11.3269L9.46588 15.3762H16.1476V13.3003ZM19.9657 11.7707H11.7992L13.6565 9.69476H19.9657V11.7707Z",
    fill: "#6D6D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickEdit);
export default __webpack_public_path__ + "static/media/quick-edit.1a491be3f0ed9ea5e5fb3692a5fb6e44.svg";
export { ForwardRef as ReactComponent };